import React from 'react';
import { IComponentActInfo } from '../../component';
import ActInfo from './ActInfo';
import { inject, observer } from 'mobx-react';

const AllForActInfo = function(props: IComponentActInfo) {
  let { pagedataStore, videoStore } = props.rootStore;
  return (
    <div className="all-for-actinfo">
      <ActInfo
        {...props}
        {...pagedataStore.getViewDetail()}
        {...videoStore.currentGallerys}
      />
    </div>
  );
};

export default inject('rootStore')(observer(AllForActInfo));
